import apiClient from "../../../api/apiClient";

export const updateScaleNotesApi = async (
  id: string,
  data: {
    location: string;
    comment: string;
  },
  tenantId: string,
) => {
  return apiClient.put(`/operation/scales/${id}/notes`, data, {
    params: {
      tenantId,
    },
  });
};

// ================= GET SCALES BY CUSTOMER =================

export const getScalesByCustomerApi = async (
  customerId: string,
  tenantId: string,
) => {
  const res = await apiClient.get(`/operation/scales/customer/${customerId}`, {
    params: {
      tenantId,
    },
  });

  return res.data;
};

// ================= UPDATE =================

export const updateScaleApi = async (data: any, tenantId: string) => {
  const res = await apiClient.put("/operation/scales", data, {
    params: {
      tenantId,
    },
  });

  return res.data;
};

// ================= DELETE =================

export const deleteScaleApi = async (id: string, tenantId: string) => {
  const res = await apiClient.delete(`/operation/scales/${id}`, {
    params: {
      tenantId,
    },
  });

  return res.data;
};

// ================= GET ALL =================

export const getScalesApi = async (
  page: number,
  pageSize: number,
  search: string,
  tenantId: string,
) => {
  const res = await apiClient.get("/operation/scales", {
    params: {
      PageNumber: page,
      PageSize: pageSize,
      Search: search,
      tenantId,
    },
  });

  return res.data;
};

// ================= GET BY ID =================

export const getScaleByIdApi = async (id: string, tenantId: string) => {
  const res = await apiClient.get(`/operation/scales/${id}`, {
    params: {
      tenantId,
    },
  });

  return res.data;
};

// ================= CREATE =================

export const createScaleApi = async (data: any, tenantId: string) => {
  const res = await apiClient.post("/operation/scales", data, {
    params: {
      tenantId,
    },
  });

  return res.data;
};

// ================= GET UNITS =================

export const getUnitsApi = async (tenantId: string) => {
  const res = await apiClient.get("/operation/scales/units", {
    params: {
      tenantId,
    },
  });

  return res.data;
};

export const updateScaleCommentApi = async (
  id: string,
  data: {
    comment: string;
  },
  tenantId: string,
) => {
  return apiClient.put(`/operation/scales/${id}/comment`, data, {
    params: {
      tenantId,
    },
  });
};

// ======================================================
// CREATE CALIBRATION REPORTS
// ======================================================

export interface CreateCalibrationReportsDto {
  scaleIds: string[];
}

export interface CalibrationReportBatchResultDto {
  totalRequested: number;
  createdCount: number;
  skippedCount: number;
  createdScaleIds: string[];
  skippedScaleIds: string[];
  notFoundScaleIds: string[];
}

export const createCalibrationReportsApi = async (
  data: CreateCalibrationReportsDto,
  tenantId: string,
) => {
  const res = await apiClient.post(
    "/operation/scales/calibration-reports",
    data,
    {
      params: {
        tenantId,
      },
    },
  );

  return res.data;
};
